import { render, staticRenderFns } from "./AccesibilityControls.vue?vue&type=template&id=14597f22"
import script from "./AccesibilityControls.vue?vue&type=script&lang=js"
export * from "./AccesibilityControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports